<div class="material-page">
  <mat-card>
    <mat-card-content>
      <p i18n>Please login to continue</p>
      <button mat-raised-button (click)="oauth2Login()" color="primary" i18n>Login</button>
    </mat-card-content>
  </mat-card>
</div>
